import { useState } from "react";

export default function useColumnSettings(initialColumns) {
  const [columns, setColumns] = useState({
    all: true,
    ...initialColumns
  });

  const updateColumn = (name, value) => {
    setColumns(prev => {
      const updated = { ...prev };

      // Select All clicked
      if (name === "all") {
        Object.keys(updated).forEach(k => {
          updated[k] = value;
        });
        return updated;
      }

      // Individual toggle
      updated[name] = value;

      // Sync "all"
      updated.all = Object.keys(updated)
        .filter(k => k !== "all")
        .every(k => updated[k]);

      return updated;
    });
  };

  return {
    columnSettings: columns,
    updateColumn
  };
}